import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ReferralTracker() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get("ref");

    if (ref) {
      localStorage.setItem("eyalReferral", ref);
      console.log("✅ Referral saved:", ref);
    }
  }, [location]);

  return null;
}